export default function (app) {
	app.directive('selectOnBlurAccount', function () {
		return {
			require: 'uiSelect',
			link: function (scope, elm, attrs, ctrl) {
				elm.on('blur', 'input.ui-select-search', function (e) {
					if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0) && e.target.value && e.target.value != '') {
						ctrl.select(ctrl.search);

						if (attrs.accountNumberProperty) {
							ctrl.selected = {};
							ctrl.selected[attrs.accountNumberProperty] = ctrl.search;
						} else {
							ctrl.selected = ctrl.search;
						}
					}
					e.target.value = '';
				});
			}
		};
	});
};
